import React, { Component } from 'react';
import { DragLayer } from 'react-dnd';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import SortListDragPreview from './SortListDragPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 1001,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

function getItemStyles(props) {
  const { initialOffset, currentOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

class CustomDragLayer extends Component {
  componentDidMount() {
    const body = document.getElementsByTagName('body')[0];
    this.container = document.createElement('div');
    body.appendChild(this.container);
  }

  componentWillUnmount() {
    const body = document.getElementsByTagName('body')[0];
    body.removeChild(this.container);
  }

  render() {
    const { item, isDragging, portalClassName } = this.props;
    return this.container
      ? createPortal(
          isDragging ? (
            <div style={layerStyles} className={portalClassName}>
              <div style={getItemStyles(this.props)}>
                <SortListDragPreview className={item.className} listClassName={item.listClassName}>
                  {item.item}
                </SortListDragPreview>
              </div>
            </div>
          ) : (
            <div />
          ),
          this.container,
        )
      : null;
  }
}

CustomDragLayer.defaultProps = {
  portalClassName: null,
  item: null,
};

CustomDragLayer.propTypes = {
  item: PropTypes.shape({}),
  isDragging: PropTypes.bool.isRequired,
  portalClassName: PropTypes.string,
};

export default DragLayer(monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging(),
}))(CustomDragLayer);
